// extracted by mini-css-extract-plugin
export default {"card":"GestaoPaginas_card__xGoy1","title":"GestaoPaginas_title__qU4-B","actionsHeader":"GestaoPaginas_actionsHeader__BtuEZ"};